import { useState, useEffect } from 'react'
import { fetchCalendarData } from 'src/api/sduiService'
import { CalendarScreen } from 'src/componentsV2/CoreUX/CalendarModal/CalendarModal.types'

type UseCalendarDataResult = {
  calendarData: CalendarScreen | null
  isLoading: boolean
  error: string | null
}

export const useCalendarData = (
  isOpen: boolean,
  date?: string
): UseCalendarDataResult => {
  const [calendarData, setCalendarData] = useState<CalendarScreen | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!isOpen || !date) {
      return
    }

    const fetchData = async () => {
      setIsLoading(true)
      setError(null)

      try {
        const data = await fetchCalendarData(date)
        // Cast the data to CalendarScreen type to handle string-enum type differences
        setCalendarData(data as CalendarScreen)
      } catch (err) {
        console.error('Error fetching calendar data:', err)
        setError(
          err instanceof Error
            ? err.message
            : 'An error occurred while fetching calendar data'
        )
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
  }, [date, isOpen])

  return { calendarData, isLoading, error }
}
